<form [formGroup]="form" *transloco="let fieldTranslation; read: 'field-types'">
    <div class="flex flex-col space-y-4 w-full">
        <mat-form-field class="fuse-mat-no-subscript w-full">
            <mat-label>{{ fieldTranslation("Placeholder") }}</mat-label>
            <input
                [placeholder]="fieldTranslation('Placeholder')"
                formControlName="placeholder"
                autocomplete="off"
                matInput
            />
        </mat-form-field>

        <div
            class="flex flex-col space-y-4"
            formArrayName="options"
            cdkDropList
            [cdkDropListData]="options['controls']"
            (cdkDropListDropped)="drop($event)"
        >
            <mat-label class="font-weight-500 text-lg">Adicionar opções</mat-label>

            <div
                class="flex flex-row items-center"
                *ngFor="let option of options['controls']; let i = index"
                [formGroupName]="i"
                cdkDrag
                [cdkDragData]="option"
            >
                <div class="w-16 flex justify-center">
                    <mat-icon cdkDragHandle>sort</mat-icon>
                </div>

                <mat-form-field class="fuse-mat-no-subscript fuse-mat-no-header w-full">
                    <input formControlName="text" autocomplete="off" matInput />
                </mat-form-field>

                <div class="w-24 flex justify-center">
                    <button mat-icon-button *ngIf="options['controls'].length > 1" (click)="deleteOption(i)">
                        <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                    </button>
                </div>

                <ng-template cdkDragPlaceholder>
                    <div
                        class="flex flex-row items-center w-full rounded-lg border-2 border-dashed border-primary-500 bg-primary-50 p-2 opacity-70"
                    >
                        <div class="w-16 flex justify-center">
                            <mat-icon class="text-primary-500">drag_indicator</mat-icon>
                        </div>
                        <div class="flex-1 h-10 bg-primary-100 rounded"></div>
                        <div class="w-24 flex justify-center">
                            <mat-icon class="text-primary-400">delete</mat-icon>
                        </div>
                    </div>
                </ng-template>
            </div>

            <div class="flex flex-row items-center place-content-start">
                <button mat-button color="primary" (click)="addOption()">Adicionar opção</button>
            </div>
        </div>
    </div>
</form>
